import { render, staticRenderFns } from "./BlocksTransactionsRowMobile.vue?vue&type=template&id=c524bc9a"
import script from "./BlocksTransactionsRowMobile.vue?vue&type=script&lang=js"
export * from "./BlocksTransactionsRowMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports